import { render, staticRenderFns } from "./Minimoainvertir.vue?vue&type=template&id=20b8567a&scoped=true&"
import script from "./Minimoainvertir.vue?vue&type=script&lang=ts&"
export * from "./Minimoainvertir.vue?vue&type=script&lang=ts&"
import style0 from "./Minimoainvertir.vue?vue&type=style&index=0&id=20b8567a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8567a",
  null
  
)

export default component.exports